export default __webpack_public_path__ + "static/marketing-photo-f4e0a93416c9be68020abff2ae8a77a5.webp";